import React, { FunctionComponent } from 'react';
import { Grid, Link as MaterialLink, Typography } from '@material-ui/core';
import clsx from 'clsx';
import LabelAndPrice from '../../labels/LabelAndPrice';
import expandedSectionStyles from '../ExpandedSectionStyles';
import { IPrice } from '../../../../../../../../../common/model/IPrice';
import dealPriceAccessor from '../../../../../../../common/service/dealPriceAccessor';
import usePlatformConfig from '../../../../../../../common/react/usePlatformConfig';
import ICarConfigOption from '../../../../../../../../../common/model/ICarConfigOption';
import { CustomiseSections } from '../../../../../../../common/enum/CustomiseSections';
import useScrollToSection from '../../../../../../react/navigation/useScrollToSection';
import IndicativeNumber from '../../../../../../../common/components/indicativeNumber/IndicativeNumber';
import Translation from '../../../../../../../common/components/translation/Translation';

export interface IServicePlanSectionProps {
  servicePlan: ICarConfigOption;
  removeAction: (category: string, optionId?: string) => void;
}

const ServicePlanSection: FunctionComponent<IServicePlanSectionProps> = ({ servicePlan, removeAction }) => {
  const styles = expandedSectionStyles();
  const {
    platformConfig: { priceDisplay },
  } = usePlatformConfig();
  const planPrice: IPrice = dealPriceAccessor.getPrimaryPrice(servicePlan.prices, priceDisplay);
  const { scrollToDisclaimer } = useScrollToSection();

  return (
    <Grid item={true} data-test="summary_expanded:section:servicePlan">
      <Typography variant={'body1'} className={clsx([styles.bolded, styles.subtitle])}>
        <Translation id={'spc.customise.servicePlan'} />
        <IndicativeNumber
          dataTest="servicePlan"
          displayNumber={<Translation id="spc.customise.indicative.servicePlan" />}
          onClick={scrollToDisclaimer}
        />
      </Typography>
      <LabelAndPrice
        label={servicePlan.title}
        price={planPrice?.basePrice}
        currency={planPrice.currency}
        priceType="servicePlan"
        isMainText={false}
        decimals={priceDisplay.primaryOptions.decimalScale}
      />
      <MaterialLink
        onClick={() => removeAction(CustomiseSections.SERVICE_PLAN)}
        variant={'helpingText'}
        className={styles.changeAction}
        underline={'always'}
        color={'secondary'}
        data-test={'plan:button:remove'}
      >
        <Translation id={'spc.customise.button.remove'} />
      </MaterialLink>
    </Grid>
  );
};

export default ServicePlanSection;
